var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass},[_vm._t("loading",null,{"loading":_vm.loading}),_vm._l((_vm.feeds),function(feed,index){return _vm._t("feeds",null,{"index":index,"feed":feed})}),_vm._t("error",null,{"error":_vm.error})],2)}
var staticRenderFns = []

export { render, staticRenderFns }